export default "__VITE_ASSET__DQx$1kS7__"